import { ResponseBase } from '@/services/types'
import { shopCLient } from '../../axiosConfig'

export interface SubcategoryRes {
  productSubCategoryList: Subcategory[]
}
export interface Subcategory {
  id: number
  name: string
  link: string
}

export type GetSubcategories = () => Promise<ResponseBase<SubcategoryRes>>

export const getSubcategories: GetSubcategories = async () => {
  try {
    const response = await shopCLient.get('/product/sub-category')
    return response.data
  } catch (e) {
    console.error('categories fetch failed e')
  }
}
